import Modal from './Modal';
import AvisoModal from './AvisoModal';
import styles from './ConfirmActionModal.module.css';

// Modal de confirmación genérico para acciones que NO son "eliminar" (envíos,
// acciones que suman/cambian estado, etc.) — mismo patrón que
// ConfirmDeleteModal pero sin el ícono/color rojo de borrado, que no aplica
// semánticamente a una acción distinta a eliminar.
// `error`: motivo por el que la acción NO se pudo hacer (el mensaje del servidor). Se muestra DENTRO del modal, fijo arriba (AvisoModal), porque la
// alerta de la página queda tapada por el modal; el modal sigue abierto para leer el motivo y cancelar o reintentar.
export default function ConfirmActionModal({
  title, children, onClose, onConfirm, loading, error,
  confirmLabel = 'Confirmar', confirmIcon = 'fa-check', maxWidth = 420,
}) {
  return (
    <Modal onClose={() => !loading && onClose()} maxWidth={maxWidth}>
      <div className="modal-header">
        <h3><i className={`fas fa-circle-question ${styles.iconoTitulo}`} />{title}</h3>
        <button className="btn-close" onClick={onClose} disabled={loading}>✕</button>
      </div>
      <div className="modal-body">
        {error && <AvisoModal>{error}</AvisoModal>}
        <div className={styles.caja}>
          <div className={styles.circulo}>
            <i className={`fas fa-circle-info ${styles.circuloGlifo}`} />
          </div>
          <div>{children}</div>
        </div>
      </div>
      <div className="modal-footer">
        <button className="btn btn-secondary" onClick={onClose} disabled={loading}>Cancelar</button>
        <button className="btn btn-primary" onClick={onConfirm} disabled={loading}>
          {loading
            ? <><div className={`spinner ${styles.spinner}`} /> Procesando...</>
            : <><i className={`fas ${confirmIcon}`} /> {confirmLabel}</>}
        </button>
      </div>
    </Modal>
  );
}
